import Config from '../config/env_variables';

const isProd = Config.REACT_APP_NODE_ENVIRONMENT === 'prod';

class Logger {
  debug = (...args) => {
    if (isProd) return;
    console.debug(...args);
  }

  info = (...args) => {
    if (isProd) return;
    console.info(...args);
  }

  warn = (...args) => {
    console.warn(...args);
  }

  error = (...args) => {
    console.error(...args);
  }
}

export default new Logger();
